import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import 'vuetify/src/stylus/app.styl'
import 'vuetify/dist/vuetify.min.css'

/*
Vue.use(Vuetify, {
  theme: {
    primary: '#ff3131',
    secondary: '#000',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  iconfont: 'fa',
})
*/

Vue.use(Vuetify);

export default new Vuetify({
  dark: false,
  theme: {
    themes: {
      light: {
        primary: '#D32F2F',
        secondary: '#000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: '#D32F2F',
        secondary: '#000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    },
  },
  options: {
    customProperties: true
  },
  icons: {
    iconfont: 'fa',
  },
});
